module.exports = __webpack_public_path__ + "media/images/official-4-6c7c091fe08abe4bbb474ad20f63615f.png";